import { Row, Col } from "reactstrap";
import { brlMask } from "../../helpers/masks";
import { LoadingImg } from "../../helpers/images";
import { useEffect } from "react";

export function Tickets({ tickets, handleAdd, handleRemove, handleBuy, t }) {

  useEffect(() => {
    console.log("tickets", { tickets })
  }, [tickets]);

  if (tickets.length === 0) {
    return (
      <Row>
        <Col className="d-flex flex-row justify-content-center align-items-center mb-3">
          <img alt="..." src={LoadingImg} className="w-25" />
        </Col>
      </Row>
    );
  }

  const categorize = (ticket) => {
    const desc = ticket.description.toLowerCase();

    const has28 = desc.includes("28/05");
    const has29 = desc.includes("29/05");

    if (has28 && has29) return "28/05 e 29/05";
    if (has28) return "28/05";
    if (has29) return "29/05";

    return "Outros";
  };

  const groupedTickets = tickets.reduce((acc, ticket, index) => {
    const category = categorize(ticket);
    const item = { ...ticket, globalIndex: index };

    if (!acc[category]) acc[category] = [];
    acc[category].push(item);

    return acc;
  }, {});

  const categoryOrder = ["28/05 e 29/05", "28/05", "29/05", "Outros"];

  return (
    <>
      {categoryOrder.map((groupTitle) =>
        groupedTickets[groupTitle]?.length ? (
          <Row key={groupTitle}>
            <Col>
              <table className="table table-bordered align-middle">
                <tbody>
                  {groupedTickets[groupTitle].map((ticket, index) => (
                    <tr key={index}>
                      <td>{ticket.description}</td>
                      <td>{brlMask(ticket.price)}</td>
                      <td>
                        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-outline-secondary w-50"
                            onClick={(e) => handleRemove(e, ticket.globalIndex)}
                          >
                            <i className="bi bi-dash"></i>
                          </button>
                          <span className="p-1">{ticket.count}</span>
                          <button
                            className="btn btn-outline-secondary w-50"
                            onClick={(e) => handleAdd(e, ticket.globalIndex)}
                          >
                            <i className="bi bi-plus"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Col>
          </Row>
        ) : null
      )}
      <Row>
        <Col className="mb-3">
          <button
            className="btn btn-outline-secondary w-100"
            onClick={handleBuy}
          >
            <i className="bi bi-cart-check me-2"></i>
            {t("tickets.fields.tobuy")}
          </button>
        </Col>
      </Row>
    </>
  );
}
